import { AuthorizationGroup } from 'jsx/@types/authorization';

// Only superadmin has system_id property
export default function isSystemGroup(group: AuthorizationGroup): boolean {
  return !!group.system_id;
}
